import type { Student } from 'src/dto/Student'
import type { DateStr } from 'src/types/common/commonTypes'

import { EMPTY_NUMBER_ID } from '@/constant/common'
import { Day } from '../common/Calendar/Day'
import { DTO } from '../DTO'

type constructorParams = {
  id?: number
  fee?: number
  memo?: string
  studentId: Student['id']
  paymentDate: DateStr<'-'>
  lessonStartDate: DateStr<'-'> | null
  lessonEndDate: DateStr<'-'> | null
}

export class Tuition extends DTO {
  id = EMPTY_NUMBER_ID
  lessonStartDate: DateStr<'-'> | null = null
  lessonEndDate: DateStr<'-'> | null = null
  fee = 0
  memo = ''
  studentId: Student['id']
  paymentDate: DateStr<'-'>

  constructor({ studentId, paymentDate, ...data }: constructorParams) {
    super()
    this.studentId = studentId
    this.paymentDate = paymentDate
    this.update<Tuition>(data)
  }

  get paymentDay() {
    return new Day(this.paymentDate)
  }
}

export default Tuition
